<template>
    <span v-if="saison">
        <confirm-dialog :open="confirmDelete.open" :header="confirmDelete.header"
                        :question="confirmDelete.question"
                        @reply="processConfirm" :query-parameter="'confirmSpielPlanDelete'+saison.id">
        </confirm-dialog>
    </span>
</template>

<script>
    import ConfirmDialog from "../../components/navigation/confirmDialog";
    import {db} from "../../services/db";
    import {firestore} from "../../services/db";

    export default {
        components: {
            ConfirmDialog},
        name: "spiel-plan-delete-all-games",
        props: ['saison'],
        data: () => ({
            confirmDelete: {
                open: false,
                question: '',
                item: null,
            },
            //itemTemp: null,
        }),
        computed: {
            openDialog(){ return this.$route.query.action==='deleteSaisonGames'; }
        },
        methods: {
            requestDeleteConfirm(){
                this.confirmDelete.header = 'Alle geplanten Spiele löschen';
                this.confirmDelete.question = "Möchtest du wirklich alle geplanten Spiele sowie " +
                    "alle spielfreien Mannschaften für dieses Saison " +
                    "endgültig und unwiderruflich löschen?";
                this.confirmDelete.open = true;
            },
            processConfirm(reply) {
                if ( reply ) {
                    this.deleteAlleSpiele();
                }
                this.confirmDelete.open = false;
                window.history.back();
            },
            async deleteAlleSpiele(){
                let batch = db.batch();
                let counter = 0;
                this.$store.state.local.loader = true;
                Object.keys(this.saison.spiele).forEach( (spielId) => {
                    const spiel = this.saison.spiele[spielId];
                // only applicable if spiel is planned
                    if ( spiel.vereine.heim.indexOf('pending') !== -1 &&
                        !spiel.referee.name &&
                        (spiel.heim.result.kegel + spiel.gast.result.kegel) === 0
                    ) {
                        counter++;
                    // add spiel delete to batch
                        console.log ("Delete spiel: ", this.saison.spiele[spielId].saison.id, spielId);
                        batch.delete(db.collection("spiele").doc(spielId));
                    // add spielKey delete in saison to update
                        this.saison.local.documentUpdates['spiele.' + spielId] = firestore.FieldValue.delete();
                    }
                });
            // if there are any deleteable games
                if ( counter > 0 ) {
                // delete from saison
                    this.saison.local.documentUpdates.spielfrei = {};
                    await this.saison.saveEdited('saison_edit');
                // delete games
                    batch.commit().then(() => {
                        this.$store.state.local.loader = false;
                        this.$store.state.globalSnack.text = 'Die Spiele wurden erfolgreich gelöscht';
                        this.$store.state.globalSnack.color = 'success';
                        this.$store.state.globalSnack.show = true;
                    });
                } else {
            // otherwise
                    this.$store.state.local.loader = false;
                    this.$store.state.globalSnack.text = 'Es können keine Spiele gelöscht werden!';
                    this.$store.state.globalSnack.color = 'error';
                    this.$store.state.globalSnack.show = true;
                }

            },
        },
        watch: {
            openDialog(to, from){
                if ( to && !from ) {
                    this.requestDeleteConfirm();
                }
            }
        }
    }

</script>

<style scoped>

</style>